import { CustomerOrderBase } from '../../contracts/customer-order.js';
import { Currency } from '../../models/serializable/currency.js';
import { Price } from '../../models/serializable/price.js';
import { LegacyOrderDiscountBreakdown } from './discount-breakdown.js';
import { LegacyOrderFeeBreakdown } from './fee-breakdown.js';
import { IOrderPriceBreakdown } from './order-price-breakdown.js';
import { IPaymentHelperConfig } from './payment-helper-config.js';

export abstract class IPaymentHelperAdapter {
  abstract get orderTypeId(): string;

  abstract getCurrencyOfOrder(order: CustomerOrderBase): Currency | null;
  abstract calculateDiscountForOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): Price | null;
  abstract calculateCheckoutPriceBreakdownForOnlineOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): IOrderPriceBreakdown | null;
  abstract calculateDiscountBreakdownForOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): LegacyOrderDiscountBreakdown | null;
  abstract calculateFeeBreakdownForOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): LegacyOrderFeeBreakdown | null;
  abstract calculateCheckoutPriceForOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): Price | null;
  abstract calculateCheckoutPriceForDiscountProvider(order: CustomerOrderBase, config: IPaymentHelperConfig): Price | null;
  abstract calculateIncomeForOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): Price | null;
  abstract calculateIncomeWithoutDiscountForOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): Price | null;
  abstract canCreateRefundForOnlineOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): boolean | null;
  abstract calculateExistingRefundForOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): Price | null;
  abstract calculateRemainingRefundForOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): Price | null;
  abstract calculateMaxRefundForOnlineOrder(order: CustomerOrderBase, config: IPaymentHelperConfig): Price | null;
}
